export default __webpack_public_path__ + "static/media/spotify.1b86cf97.png";